export const PHONE_DISPLAY = "(484) 544-3345";
export const PHONE_TEL = "tel:+14845443345";
export const ADDRESS_LINE1 = "229 S. 22nd St.";
export const ADDRESS_LINE2 = "Easton, PA 18042";

export const VISITS = {
  hormone: {
    key: "hormone",
    label: "Hormone health or functional medicine",
    name: "Your first hormone or functional medicine visit",
    duration: "60 minutes",
    price: "$400",
  },
  joint: {
    key: "joint",
    label: "Joint or muscle pain",
    name: "Your first joint or muscle pain visit",
    duration: "45 minutes",
    price: "$300",
  },
};

export const CONCERN_OPTIONS = [
  { value: "hormone", label: "Menopause, perimenopause, or hormone health" },
  { value: "functional", label: "Functional medicine or broader wellness concerns" },
  { value: "joint", label: "Joint or muscle pain" },
  { value: "unsure", label: "I'm not sure yet" },
];

export const visitForConcern = (concern) =>
  concern === "joint" ? VISITS.joint : concern === "unsure" ? null : VISITS.hormone;

// Athena self-scheduling links per visit type (from the practice's booking-links CSV).
// Athena's patient scheduling page does not support deep-linking a specific
// appointment type, so both routes open the practitioner page and the quiz tells
// the patient exactly which visit type to choose.
const ATHENA_SCHEDULING_URL =
  "https://consumer.scheduling.athena.io/?locationId=33972-1&practitionerId=33972-1";

export const BOOKING_LINKS = {
  hormone: ATHENA_SCHEDULING_URL, // choose "NEW PATIENT 60"
  joint: ATHENA_SCHEDULING_URL, // choose "New patient 45"
};

export const BOOKING_CHOICE = {
  hormone: "NEW PATIENT 60",
  joint: "New patient 45",
};

export const SYMPTOMS = [
  "Hot flashes or night sweats",
  "Sleep changes",
  "Brain fog or difficulty concentrating",
  "Fatigue or changes in energy",
  "Weight or body-composition concerns",
  "Questions about perimenopause, menopause, or hormone treatment",
];

export const VISIT_INCLUDES = [
  "Time directly with Dr. Crosson",
  "A detailed health history and timeline",
  "Review of available previous labs and imaging when relevant",
  "A physical examination",
  "Vitals and an included InBody body-composition assessment",
  "Discussion of next steps and any testing she recommends",
];

export const FAQS = [
  {
    q: "Do you accept insurance?",
    a: "No. All-In Precision Wellness is a private-pay practice. Choosing not to contract with insurance companies lets Dr. Crosson set aside dedicated, unhurried time for each visit. We provide a superbill and receipt for your records, which you may submit to your insurance if you choose. Reimbursement depends on your individual plan.",
  },
  {
    q: "What does the first visit cost?",
    a: "A first hormone or functional medicine visit is $400 for 60 minutes with Dr. Crosson. Visits are billed at $100 per 15 minutes, based on time spent.",
  },
  {
    q: "How long is the visit?",
    a: "Your first hormone or functional medicine visit is scheduled for a full 60 minutes with Dr. Crosson.",
  },
  {
    q: "What happens during the visit?",
    a: "You spend the hour directly with Dr. Crosson. She takes a detailed health history and timeline, reviews any previous labs or imaging you can share, performs a physical examination, checks vitals, includes an InBody body-composition assessment, and talks through next steps and any testing she recommends.",
  },
  {
    q: "Do I need to know whether I'm in menopause?",
    a: "No. You don't need to arrive with answers. The visit is designed to talk through what has changed and consider what needs a closer look.",
  },
  {
    q: "Will I automatically receive hormone therapy?",
    a: "No. Your visit starts with a conversation, not a predetermined treatment. If you're interested in bioidentical hormone therapy, bring those questions. Dr. Crosson can discuss whether hormone treatment is appropriate based on your individual evaluation.",
  },
  {
    q: "Should I get blood work before the appointment?",
    a: "Generally, no. Dr. Crosson prefers to evaluate you first, then order testing specific to you. If you have existing records or recent results, the office can coordinate receiving them before your visit.",
  },
  {
    q: "Can you review my existing test results?",
    a: "Yes. Bring available previous labs and imaging, or contact the office ahead of time so records can be coordinated before the visit.",
  },
  {
    q: "What happens if I cancel?",
    a: "Please give at least 24 hours notice if you need to cancel or reschedule. Cancellations less than 24 hours before the appointment incur a $100 cancellation fee.",
  },
  {
    q: "Where is the office?",
    a: `${ADDRESS_LINE1}, ${ADDRESS_LINE2}. Call ${PHONE_DISPLAY} with any questions about parking or directions.`,
  },
];
